import { watch } from 'vue';

export function useNoReactive<T>(getter: () => T, errorMessage?: string): T {
  watch(getter, () => {
    throw new Error(errorMessage ?? "The property isn't supposed to be changed ever");
  });
  return getter();
}
